'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hamburgler = void 0;
var $ = require("jquery");
var Hamburgler = /** @class */ (function () {
    function Hamburgler() {
        $('.trigMenu').on('click', function () {
            var isOpen = $('.paramMenu').attr('data-is-open');
            if (isOpen == 'false') {
                $('html body').css('overflow', 'hidden');
                $('.bulletMenu').attr('data-is-open', 'true');
                $('.bulletNavi').fadeIn(500);
                $('#bulletSpNavi').addClass('no-hamburgler');
            }
            else {
                $('html body').css('overflow', 'auto');
                $('.bulletMenu').attr('data-is-open', 'false');
                $('.bulletNavi').fadeOut(500);
                $('#bulletSpNavi').removeClass('no-hamburgler');
            }
        });
    }
    return Hamburgler;
}());
exports.Hamburgler = Hamburgler;
exports.default = Hamburgler;
